export * from './BannerWide';
